import {
    doResultListUpdate
} from './_doResultListUpdate';
import {
    scrollbar
} from '../global/_scrollbar';
import {
    doScrollToTop
} from '../global/_scroll';

export var facetBinds = () => {
    $('.facet').on('click', 'a.facet-href', function (event) {
        $(this).parent().siblings('input').trigger('click');
        return false;
    }).on('click', '.GuidedNavColorSwatch', function (event) {
        $(this).siblings('label').children('input').trigger('click');
        return false;
    }).on('change', 'input', function (event) {
        var $this = $(this);
        var hidImage = false;
        if ($this.data("dontfirecheck") != "true") {
            const setGhostDiv = (gdHeight, mfsHeight) => {
                if (gdHeight !== mfsHeight + 30) $('#ghostDiv').css('height', mfsHeight + 30);
            }
            const setFilterCount = (filterCount_display) => {
                $('#filterCount').html(`(${filterCount_display})`);
                $('#filterCountResults').html(` (${filterCount_display})`);
            }
            if ($(this).prop("checked") == true) {
                $this.parent("div").addClass("checked");
                if ($('.mobilePage').length > 0) {
                    $('#selectedFilterWrapper').append(`<div class="selectedFilter" id="selectedFilter${$this.attr("id")}"><span class="selectedFilter--title">${$this.parents("li").find("label > span").data("prettyattr")}</span><span class="remove-filter">×</span></div>`);
                    if (!$('#mobileFilterSelected, #ghostDiv').hasClass('active')) $('#mobileFilterSelected, #ghostDiv').addClass('active');
                    setGhostDiv($('#ghostDiv').height(), $('#mobileFilterSelected').height());
                    let filterCount = $('#filterCount').data('count'),
                        filterCount_display = (filterCount == undefined) ? 1 : filterCount + 1;
                    $('#filterCount').data('count', filterCount_display);
                    if (filterCount_display == 0) $('#filterCount, #filterCountResults').html('');
                    else setFilterCount(filterCount_display);
                } else {
                    if ($('.desktopPage').length > 0) {
                        $("#facetFilterList").append('<li id="filter_' + $this.attr("id") + '"><a role="button" href="#" onclick="javascript:Dillards.facetRemoveLink(\'' + $this.attr("id") + '\'); return false;"><span class="label label-default">' + $this.parents("li").find("label > span").data("prettyattr") + '<i class="remove-filter">&times;</i></span></a></li>');
                        $("#filteredBy, .filtered-by, .clearAll").show();
                        hidImage = $('.hide-on-pagin:visible, .hide-splash:visible').length > 0;
                    }                   
                    $('.hide-on-pagin, .hide-splash').hide();
                }
            } else {
                $this.parent("div").removeClass("checked");
                if ($('.mobilePage').length > 0) {
                    $(`#selectedFilter${$this.attr("id")}`).remove();
                    setGhostDiv($('#ghostDiv').height(), $('#mobileFilterSelected').height());
                    let filterCount = $('#filterCount').data('count'),
                        filterCount_display = filterCount - 1;
                    $('#filterCount').data('count', filterCount_display);
                    if (filterCount_display == 0) {
                        $('#mobileFilterSelected, #ghostDiv').removeClass('active');
                        $('#filterCount, #filterCountResults').html('');
                    } else setFilterCount(filterCount_display);
                } else if ($('.desktopPage').length > 0) {
                    $(`#filter_${$this.attr("id")}`).remove();
                    if ($("#facetFilterList li").length == 0) $("#filteredBy,.filtered-by, .clearAll").hide();
                }           
            }
            $("#beginIndex").val("0");

            if ($('.desktopPage').length > 0) {
                if (($('#top-facets').length > 0 && $this.data("dontscroll") != "true" && !$this.is('#top-facets .facet input')) || hidImage) {
                    var scrollToFacet = $('#top-facets').offset().top - 150;
                    doScrollToTop(scrollToFacet);
                }
            }
            doResultListUpdate();
        }
    });

    //fire scrollbar if page doesn't have ajax request;
    scrollbar();
    $('.aside-facets-column, .sort-content').removeClass("hidden");
};

export var showFacets = () => {
    $('.facet-item ul li label, .landing-brand-facet-wrapper').show();
}